module.exports = __webpack_public_path__ + "static/head-pic2-275d81312763c0fc05f3678bc4b46624.png";